import React, {useRef} from 'react';
import * as css from './css/service';
import {observer} from 'mobx-react';
import Message from './partials/message/Message';
import ChatMessage from 'enum/ChatMessage';
import useMyStores from "hooks/useMyStores";
import useDidMount from "beautiful-react-hooks/useDidMount";
import {Service, ServiceWrapper} from "./css/service";

const Index = ({className}) => {
    const messageListRef = useRef(null);

    const {service: store} = useMyStores()

    useDidMount(() => {
        store.init()
    })

    const renderMessage = () => {
        return store.messageList.map((message, index) => {
            return <css.Message as={Message} key={index} message={message}/>;
        });
    };

    const scroll = () => {
        messageListRef.current.scrollTo(0, 10000);
    }


    const sendMessage = () => {
        if (!store.message || /\s/.test(store.message)) {
            store.message = '';
            return;
        }

        store.addMessage({
            message: store.message,
            userType: ChatMessage.FROM
        });
        store.sendMessage(store.message, () => {
            scroll();
        });
    }

    return (
        <css.Service className={className}>
            <css.Container>
                <css.Content>
                    <button
                        className='close-btn'
                        onClick={() => {
                            store.show = false;
                        }}
                    >
                        <div className='bg-wrapper'>
                            <img
                                className='bg'
                                src={require('./img/close-bg.png')}
                                alt=''
                            />
                        </div>
                        <img
                            src={require('./img/close-icon.png')}
                            alt=''
                            className='icon'
                        />
                        <div className='text'>关闭</div>
                    </button>
                    <div className='container' ref={messageListRef}>
                        <div className='message-list'>{renderMessage()}</div>
                    </div>
                    <div className='bg'/>
                    <div className='bg-2'/>
                </css.Content>
                <css.Bottom>
            <textarea
                className='text-input'
                value={store.message}
                placeholder='你有什么疑问吗？'
                onChange={e => {
                    const {value} = e.currentTarget;

                    store.message = value;
                }}
                onKeyDown={e=>{
                    if(e.keyCode === 13) {
                        sendMessage()
                    }
                }}
            />
                </css.Bottom>
                <css.ButtonFloor>
                    <button
                        className='send'
                        onClick={() => {
                            sendMessage()
                        }}
                    >
                        发送
                    </button>
                </css.ButtonFloor>
            </css.Container>
        </css.Service>
    );
}

export default observer(Index);
